module.exports = __webpack_public_path__ + "static/media/youshi.0d44c7fa.png";